import styled from "styled-components";
import infoIcon from "../../assets/images/icons/ic_info_signifiers.svg";
import * as Variable from "../../CSSVariables";

export const BannerStyle = styled.div`
  border: 1px solid #ff000024;
  width: 90%;
  display: flex;
  padding: 16px 16px;
  margin: 20px auto;
  border-radius: 6px;
  background-color: #ff000024;

  @media only screen and (min-width: ${Variable.mobile}) {
    width: 100%;
  }

  .icon {
    height: 24px;
    width: 24px;
    min-width: 24px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .details {
    padding: 0 12px;
    line-height: 20px;
  }
  .title {
    font-weight: 700;
    margin: 2px 0;
  }
  &.info {
    background-color: #d7fdf5;
    border: 1px solid #133844;
    color: #133844;

    .icon {
      background-image: url(${infoIcon});
    }
  }
`;
